import { Header, Footer } from "@/components/SiteChrome";
import { BrushCallout } from "@/components/BrushCallout";

export default function About() {
    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="about-page">
            <Header />
            <section className="mx-auto max-w-4xl px-4 py-20 sm:px-6">
                <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">About</div>
                <h1 className="mt-3 font-display text-5xl uppercase italic leading-[0.95] md:text-7xl text-[hsl(var(--ink))]">
                    Built for the <BrushCallout>trail</BrushCallout>, not the showroom.
                </h1>
                <div className="mt-12 space-y-6 text-lg text-[hsl(var(--ink-soft))]">
                    <p>
                        Urban Off-Road started in a garage with two trucks, one busted recovery strap, and a long
                        walk back to cell service. We sell the gear we wished we'd packed — picked because it
                        actually works, not because the catalog page looked good.
                    </p>
                    <p>
                        We focus on overlanders, trail crawlers, and daily-driver upgraders. Every product page
                        shows real fitment, real specs, and a real stock count — because nobody likes a "ships in
                        8–12 weeks" surprise after checkout.
                    </p>
                    <p>
                        We're not the biggest catalog. That's intentional. If it's listed, we've used it, broken
                        it, or watched a friend put it through hell first.
                    </p>
                </div>

                <div className="mt-16 grid gap-6 md:grid-cols-3">
                    {[
                        ["Honest fitment", "Year/make/model on every part. No 'universal' lies."],
                        ["Real stock", "If it says 25 in stock, it's 25 in the warehouse, not on a boat."],
                        ["Trail-tested", "Every category lead is run by someone who wheels weekly."],
                    ].map(([h, b]) => (
                        <div key={h} className="border-l-4 border-[hsl(var(--primary))] pl-4">
                            <div className="font-heading text-sm uppercase tracking-wider text-[hsl(var(--ink))]">{h}</div>
                            <p className="mt-2 text-sm text-[hsl(var(--ink-soft))]">{b}</p>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </div>
    );
}
